import { render } from "./TheAbout.vue?vue&type=template&id=5072ab07"
import script from "./TheAbout.vue?vue&type=script&lang=js"
export * from "./TheAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__